export const formBehaviourEnum = Object.freeze({
  MODIFY_ACCIDENT_DOCUMENT: "MODIFY_ACCIDENT_DOCUMENT",
  ERROR_DIALOG: "ERROR_DIALOG",
  ERROR_CONECTIVIDAD: "ERROR_CONECTIVIDAD",
  CREATE_ACCIDENT_DOCUMENT: "CREATE_ACCIDENT_DOCUMENT",
  RETURN_TO_FPA: "RETURN_TO_FPA",
  NOVEDAD_CONECTIVIDAD: "NOVEDAD_CONECTIVIDAD",
  ATTENTION_IN_OTHER_PROVIDER: "ATTENTION_IN_OTHER_PROVIDER",
  REPEAT_FORM: "REPEAT_FORM",
});
